module.exports = __webpack_public_path__ + "img/ManHoleUpAgainstFlow.360d178a.svg";